import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'agency_locations',
  inputShow: gql`
    query agenciyLocations($input: AgencyLocationQueryInput) {
      agencyLocations(input: $input) {
        id
        agency_id
        location_id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Agency Locations',
    group: 'Facilities',
    order: 1,
  },
};
